module.exports = __webpack_public_path__ + "img/no-photo.5809e03a.png";